import { TimeRangeType } from '../context/TimeRangeContext';
import { format as formatDateFn } from 'date-fns';

export const getStartEndDateFromRange = (
  range: TimeRangeType,
  specificDate?: Date,
): { startDate: Date; endDate: Date } => {
  const today = new Date();
  let startDate = new Date(today);
  let endDate = new Date(today);

  switch (range) {
    case '24H':
      startDate.setDate(today.getDate() - 1);
      break;
    case '7D':
      startDate.setDate(today.getDate() - 7);
      break;
    case '14D':
      startDate.setDate(today.getDate() - 14);
      break;
    case '30D':
      startDate.setDate(today.getDate() - 30);
      break;
    case '90D':
      startDate.setDate(today.getDate() - 90);
      break;
    case '6M':
      startDate.setMonth(today.getMonth() - 6);
      break;
    case '1Y':
      startDate.setFullYear(today.getFullYear() - 1);
      break;
    case 'POP':
      // For 'POP', use popDate if provided
      if (specificDate) {
        startDate = new Date(specificDate.getFullYear(), specificDate.getMonth() - 1, 1);
        endDate = new Date(specificDate.getFullYear(), specificDate.getMonth(), 0);
      }
      break;
    case 'Current compl.':
      // For 'Current compl.', use curCompDate if provided
      if (specificDate) {
        startDate = new Date(specificDate.getFullYear(), specificDate.getMonth(), 1);
        endDate = today;
      }
      break;
  }

  return { startDate, endDate };
};

export const formatDateWithFormat = (value: string | null | undefined, format: string): string => {
  if (!value) return '-';
  try {
    return formatDateFn(new Date(value), format); // 09-Sep-2025 style
  } catch {
    return '-';
  }
};

export function formatDateWithUtcOffset(date: Date, utcOffset: number, useCurrentTime = false): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  let time: string;
  if (useCurrentTime) {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    time = `${hours}:${minutes}:${seconds}`;
  } else {
    // Default to midnight
    time = '00:00:00';
  }

  const sign = utcOffset >= 0 ? '+' : '-';
  const absOffset = Math.abs(utcOffset);
  const offsetStr = `${sign}${String(absOffset).padStart(2, '0')}:00`;
  return `${year}-${month}-${day}T${time}${offsetStr}`;
}
